import CommentInfiniteScroll from './CommentInfiniteScroll';

export default CommentInfiniteScroll;
